import { FAQ_1_CONSTANTS } from "./faq_1";

/**
 * FAQ 1033 — BDU FAQs
 * Tinted panel, heading with a gradient rule, a numbered accordion whose open row
 * becomes a dark card over a tinted answer panel, and a "Contact Us" CTA.
 *
 * The category and question field configs are identical to FAQ 1 (same `faq_category`
 * / `faq_item` tables and the same Form_3 flow), so they are reused rather than
 * duplicated. Only the section-level fields differ.
 */

export const FAQ_1033_CONSTANTS = {
  DEFAULT_ROW: FAQ_1_CONSTANTS.DEFAULT_ROW,
  CATEGORY_FIELDS_CONFIG: FAQ_1_CONSTANTS.CATEGORY_FIELDS_CONFIG,
  FAQ_TABLE_FIELDS_CONFIG: FAQ_1_CONSTANTS.FAQ_TABLE_FIELDS_CONFIG,

  FAQ_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "FAQs",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "FAQs",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#000000",
    },
    {
      fieldName: "section_background_color",
      label: "Panel background",
      value: "#F7F7F7",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F7F7F7",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading — start",
      value: "#1F3D56",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#1F3D56",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under heading — end",
      value: "#7CB5E6",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#7CB5E6",
    },
    {
      fieldName: "background_color",
      label: "Open question surface",
      value: "#173551",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#173551",
    },
    {
      fieldName: "section_color",
      label: "Open question text + icon chip",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "accordion_muted_index_color",
      label: "Closed question number",
      value: "#3C3C4380",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#3C3C4380",
    },
    {
      fieldName: "accordion_answer_surface_bg",
      label: "Answer panel background",
      value: "#ECF6FF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#ECF6FF",
    },
    {
      fieldName: "accordion_answer_surface_border",
      label: "Answer panel border",
      value: "#AABFD3",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#AABFD3",
    },
    {
      fieldName: "gradient_color_3",
      label: "Contact Us gradient — start",
      value: "#FF0013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FF0013",
    },
    {
      fieldName: "gradient_color_4",
      label: "Contact Us gradient — end",
      value: "#990013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#990013",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
